import { memo, useState } from "react";
import { Accordion } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
import BasicInfosHeader from "../../components/basic-infos-header";
import GeneralInfo from "./components/general-info";
import RelatedPersons from "./components/related-persons";
import FinancialKpi from "./components/financial-kpi";
import Shareholders from "./components/shareholders";
import Ubos from "./components/ubos";
import Shareholdings from "./components/shareholdings";
import Publications from "./components/publications";
import InsolvencyPublications from "./components/insolvency-publications";
import AnnualStatements from "./components/annual-statements";
import News from "./components/news";
import MergersAndAcquisitions from "./components/mergers-and-acquisitions";
import Network from "./components/network";

const HandelsregisterDetail = ({ t, detailsQuery }) => {
    const history = useHistory();
    const [activeAccordion, setActiveAccordion] = useState(null);

    const sectionProps = {
        setActiveAccordion,
        activeAccordion,
        detailsQuery
    };

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-5">
                <Button
                    color="secondary"
                    outline
                    onClick={() => {
                        history.push({
                            search: `?tab=kyb`
                        });
                    }}
                >
                    <i className="ri-arrow-left-line me-1" />
                    {t('Back to List')}
                </Button>
            </div>

            <div>
                <Accordion
                    className="custom-accordion"
                    activeKey={['basic-infos', activeAccordion]}
                    defaultActiveKey={activeAccordion}
                >
                    <BasicInfosHeader detailsQuery={detailsQuery} />

                    <GeneralInfo {...sectionProps} />
                    <RelatedPersons {...sectionProps} />
                    <FinancialKpi {...sectionProps} />
                    <Shareholders {...sectionProps} />
                    <Ubos {...sectionProps} />
                    <Shareholdings {...sectionProps} />
                    <Publications {...sectionProps} />
                    <InsolvencyPublications {...sectionProps} />
                    <AnnualStatements {...sectionProps} />
                    <News {...sectionProps} />
                    <MergersAndAcquisitions {...sectionProps} />
                    <Network {...sectionProps} />
                </Accordion>
            </div>
        </div>
    );
};

const mapStatetoProps = (state) => ({
    organization: state.Organization,
    user: state.Login
});

export default withNamespaces()(
    withRouter(connect(mapStatetoProps, {})(memo(HandelsregisterDetail)))
);
